module.exports = __webpack_public_path__ + "static/assets/3fd259245351690015b4e0dac20045a1.png";